import preparedReducer from './reducer';
import { requestBIFormsByCategory, requestBIFormsByDate, requestBIFormsByForm, requestBIFormsBySiteAndDate } from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'biForms';

export const selectors = (state) => state[SLICE_NAME];

export const actions = {
  requestBIFormsBySiteAndDate,
  requestBIFormsByDate,
  requestBIFormsByCategory,
  requestBIFormsByForm,
};
